import "./OldClientsView.scss";
import { connect } from "react-redux";
import * as actions from "../../core/store/actions";
import { Card } from "@material-ui/core";
import CompaniesTable from "../../components/CompaniesTable/CompaniesTable";
import Spacer from "../../components/Spacer/Spacer";
import { AmlState } from "../../core/types/state/AmlState";
import { Fragment, useEffect, useState } from "react";
import Placeholder from "../../components/Placeholder/Placeholder";
import { CompanyMember } from "../../core/types/entity/CompanyMember";
import { ModalMessage } from "../../core/types/UI/ModalMessage";
import HistoryView from "../History/HistoryView";
import Modal from "../../components/Modal/Modal";
import { oldClientsConfiguration } from "../../core/utilities/configurations";
import DocumentCompany, { DOCUMENT_COMPANY_TYPE } from "../../core/types/DocumentCompany";
import { downloadDocument } from "../../core/utilities/documentHandler";

function OldClients(props: {
  aml?: AmlState;
  onGetCompanies?: any;
  onGetHistory?: any;
  setSelectedRegistry: any;
  onSetAtecoCode?: any;
  setDataSuccess?: boolean;
  onResetSetDataSuccess?: any;
  onGetChamberByCompany?: any;
  onDocumentSelected?: any;
  resetDocumentSelected: any;
  documentSelected?: DocumentCompany;
  chamberViewSelected: DocumentCompany;
  documentLoading: boolean;
}) {
  const [modalMessage, setModalMessage] = useState<ModalMessage>({
    showModal: false,
  });

  useEffect(() => {
    props.onGetCompanies(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  console.log("ciao", props.documentSelected)

  useEffect(() => {
    if (props.documentSelected && props.documentSelected.fileContent) {
      downloadDocument(props.documentSelected);
      props.resetDocumentSelected();
    }
  }, [props.documentSelected]);

  useEffect(() => {
    if (props.setDataSuccess === true) {
      props.onResetSetDataSuccess();
      props.onGetCompanies(true);
    }
  }, [props.setDataSuccess]);

  useEffect(() => {
    if (props.aml?.selectedRegistry) onShowModal(props.aml?.selectedRegistry);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.aml?.selectedRegistry]);

  const onHistoryClick = (companyId: number, row: CompanyMember) => {
    props.onGetHistory(companyId, row);
  };

  const onShowModal = (row: CompanyMember) => {
    const modalMessageConfirm: ModalMessage = {
      showModal: true,
      modalTitle: `STORICO: ${row.lastName} ${row.firstName}`,
      modalComponent: <HistoryView registry={row} />,
      onClose: () => props.setSelectedRegistry(),
    };
    setModalMessage(modalMessageConfirm);
  };

  const onHandleSetAtecoCode = (id: number, atecoCode: any) => {
    props.onSetAtecoCode(id, atecoCode);
  };

  const onHandleChamberView = (id: number) => {
    props.onGetChamberByCompany(id);
  };

  return (
    <Fragment>
      <Modal modalMessage={modalMessage} />
      <Card className="companies-view-container">
        <Spacer direction="vertical" size="m" />
        <div className="companies-table-container">
          {props.aml &&
          props.aml.data?.oldCompanies &&
          props.aml.data?.oldCompanies.length > 0 ? (
            <CompaniesTable
              showDeleteCompany={false}
              onHistoryClick={onHistoryClick}
              title="Vecchi clienti"
              tableConfig={oldClientsConfiguration}
              companies={props.aml.data.oldCompanies}
              onHandleChamberView={(id: number) => onHandleChamberView(id)}
              chamberView={props.chamberViewSelected}
              onSetAtecoCode={(id: number, atecoCode: any) =>
                onHandleSetAtecoCode(id, atecoCode)
              }
              onDocumentSelected={(
                id: number,
                documentType: DOCUMENT_COMPANY_TYPE
              ) => props.onDocumentSelected(id, documentType)}
              documentLoading={props.documentLoading}
            />
          ) : (
            <Placeholder message="Nessun cliente ha rescisso il contratto" />
          )}
        </div>
      </Card>
    </Fragment>
  );
}

const mapStateToProps = (state: any) => {
  return {
    aml: state.aml,
    setDataSuccess: state.aml.setDataSuccess,
    documentLoading: state.UI.documentLoading,
    chamberViewSelected: state.aml.chamberViewSelected,
    documentSelected: state.aml.documentSelected
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onGetCompanies: () => {
      dispatch(actions.getOldCompanies());
    },
    onGetHistory: (companyId: number, registry: CompanyMember) => {
      dispatch(actions.getHistory(companyId, registry));
    },
    setSelectedRegistry: (registry?: CompanyMember) => {
      dispatch(actions.setSelectedRegistry(registry));
    },
    onSetAtecoCode: (companyId: number, atecoCode: any) => {
      dispatch(actions.setAtecoCode(companyId, atecoCode));
    },
    onResetSetDataSuccess: () => {
      dispatch(actions.resetSetDataSuccess());
    },
    onGetChamberByCompany: (id: number) => {
      dispatch(actions.getChamberByCompany(id));
    },
    onDocumentSelected: (
      companyId: number,
      documentType: DOCUMENT_COMPANY_TYPE
    ) => {
      dispatch(actions.getDocumentCompany(companyId, documentType));
    },
    resetDocumentSelected: () => {
      dispatch(actions.resetDocumentSelected())
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OldClients);
